import PageShell from "@/components/PageShell";
import { usePageContent } from "@/hooks/usePageContent";
import { useSEO } from "@/hooks/useSEO";

export default function PrivacyPage() {
  const { content: c } = usePageContent("privacy");

  useSEO({
    seo_title: "Privacy Notice | SellLocalHomes",
    seo_description: "Read our privacy notice to understand how we collect, use and protect your personal data."
  });

  return (
    <PageShell>
      <div className="min-h-screen">
      
      <section className="pt-12 md:pt-16 pb-16 px-6">
        <div className="max-w-3xl mx-auto">
          <h1 className="font-serif text-3xl md:text-4xl font-medium mb-2">{c?.privacy_title || "Privacy Notice"}</h1>
          <p className="text-sm text-muted-foreground mb-8">{c?.privacy_last_updated || "Last updated: February 2026"}</p>

          <div className="prose prose-sm max-w-none space-y-6 text-muted-foreground">
            <section>
              <h2 className="font-serif text-lg font-medium text-foreground">{c?.privacy_intro_title || "Introduction"}</h2>
              <p>{c?.privacy_intro || "This privacy notice explains how we collect, use, store and protect your personal information when you use our website and services. We are committed to ensuring your privacy is protected."}</p>
            </section>

            <section>
              <h2 className="font-serif text-lg font-medium text-foreground">{c?.privacy_collect_title || "Information We Collect"}</h2>
              <p>{c?.privacy_collect || "We may collect personal information including your name, email address, phone number, and property enquiry details when you submit forms on our website. We also collect technical data such as IP addresses, browser type, and pages visited through cookies and analytics."}</p>
            </section>

            <section>
              <h2 className="font-serif text-lg font-medium text-foreground">{c?.privacy_use_title || "How We Use Your Information"}</h2>
              <p>{c?.privacy_use || "We use your information to respond to property enquiries, send property brochures, improve our website, and communicate with you about our services. We will not share your personal data with third parties without your consent, except where required by law."}</p>
            </section>

            <section>
              <h2 className="font-serif text-lg font-medium text-foreground">{c?.privacy_cookies_title || "Cookies"}</h2>
              <p>{c?.privacy_cookies || "Our website uses cookies to distinguish you from other users. This helps us provide you with a good experience when you browse our website and allows us to improve our site. You can set your browser to refuse cookies, but some features may not function properly."}</p>
            </section>

            <section>
              <h2 className="font-serif text-lg font-medium text-foreground">{c?.privacy_rights_title || "Your Rights"}</h2>
              <p>{c?.privacy_rights || "You have the right to access, correct, or delete your personal data. You may also object to processing or request data portability. To exercise these rights, please contact us using the details provided on our Contact page."}</p>
            </section>

            <section>
              <h2 className="font-serif text-lg font-medium text-foreground">{c?.privacy_retention_title || "Data Retention"}</h2>
              <p>{c?.privacy_retention || "We retain your personal data only for as long as necessary to fulfil the purposes we collected it for, including satisfying any legal, accounting, or reporting requirements."}</p>
            </section>

            <section>
              <h2 className="font-serif text-lg font-medium text-foreground">{c?.privacy_contact_title || "Contact Us"}</h2>
              <p>{c?.privacy_contact || "If you have any questions about this privacy notice or our data practices, please contact us through our Contact page."}</p>
            </section>
          </div>
        </div>
      </section>
      </div>
    </PageShell>
  );
}
